import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'
import { useSelector } from 'react-redux'
import { store } from './../../redux/store'
//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
const abilityList = JSON.parse(localStorage.getItem("abilityList"));
// console.log('aux : ', aux)
// const abilityList  = store.getState().root
// console.log('abilityList : ', abilityList)
// const abilitiArray = abilityList;
const existingAbility = abilityList ? abilityList : null
// console.log('existingAbility : ', existingAbility)

export default new Ability(existingAbility || initialAbility)
